import React from 'react';
import { Wine, Phone, WhatsappLogo, MapPin, Clock, ForkKnife, PawPrint, Laptop } from '@phosphor-icons/react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import WagAndWineSection from '../components/landing/WagAndWine';
import BrandHero, { BrandHeroCopy } from '../components/landing/BrandHero';

const PHONE_DISPLAY = '+91 88617 12345';
const PHONE_TEL = 'tel:+918861712345';
const WHATSAPP_URL = 'https://wa.me/918861712345';
const ADDRESS =
  'Survey No 136/18, V Kallhalli, Sarjapura Main Road, Anekal TQ, Bangalore 562125';

const hours = [
  { day: 'Monday – Sunday', time: '10:00 AM – 10:00 PM' },
  { day: 'Live acoustic nights', time: 'Every Friday' },
];

const WagAndWinePage = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <BrandHero
      image="/images/wag-and-wine.png"
      imageAlt="Wag & Wine — pet-safe café next to the play area"
      className="min-h-[560px] lg:min-h-[78vh]"
    >
      <BrandHeroCopy
        logo="/images/logo-wag-wine.png"
        logoAlt="Wag & Wine"
        eyebrow="A PetCart venture"
        phrases={['Everything is fine', 'when you are with', 'Wag & Wine.']}
        subtitle="A cozy pet cafe where wagging tails, good vibes and great times come together."
        features={[
          { icon: Wine, label: 'Petcafe', sub: 'Hooman friendly' },
          { icon: ForkKnife, label: 'Food for both', sub: 'Plates for you and them' },
          { icon: PawPrint, label: 'Play areas', sub: 'Doggie pool & lawn' },
          { icon: Laptop, label: 'Work from cafe', sub: 'Stay as long as you like' },
        ]}
        featuresInline
        actions={(
          <>
            <a
              href={PHONE_TEL}
              className="inline-flex h-10 items-center gap-2 rounded-full bg-[#d54a30] px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#b73e26]"
            >
              <Phone size={15} weight="fill" />
              Call to reserve
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-10 items-center gap-2 rounded-full border border-white/40 bg-white/10 px-5 text-sm font-semibold text-white backdrop-blur transition hover:bg-white/20"
            >
              <WhatsappLogo size={15} weight="fill" />
              WhatsApp us
            </a>
          </>
        )}
      />
    </BrandHero>

    {/* Reused café section with bento gallery, birthday spotlight, events, amenities */}
    <WagAndWineSection />

    {/* Visit info */}
    <section className="bg-neutral-100 py-14 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="landing-section-header">
          <span className="landing-eyebrow !bg-transparent !border-primary/30 !rounded-md">
            Plan your visit
          </span>
          <h2 className="landing-section-title">Drop by, stay a while</h2>
          <p className="landing-section-lede mx-auto">
            We're open every day. Reservations recommended for Friday nights and weekend evenings.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="rounded-2xl border border-neutral-200 bg-white p-6">
            <Clock size={22} weight="duotone" className="mb-3 text-primary" />
            <p className="landing-card-label">Hours</p>
            <ul className="mt-3 space-y-2">
              {hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-3 text-sm">
                  <span className="text-neutral-600">{h.day}</span>
                  <span className="font-medium text-neutral-900">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-neutral-200 bg-white p-6">
            <MapPin size={22} weight="duotone" className="mb-3 text-primary" />
            <p className="landing-card-label">Find us</p>
            <p className="mt-2 text-sm text-neutral-600">{ADDRESS}</p>
            <a
              href="https://maps.google.com/?q=PetCart+Nest+Sarjapura+Bangalore"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-block text-xs font-semibold uppercase tracking-wide text-primary"
            >
              Open in Maps →
            </a>
          </div>

          <div className="rounded-2xl border border-neutral-200 bg-white p-6">
            <Phone size={22} weight="duotone" className="mb-3 text-primary" />
            <p className="landing-card-label">Reservations</p>
            <p className="mt-2 text-sm text-neutral-600">
              Birthday hostings, private bookings or Friday acoustic nights — give us a ring.
            </p>
            <a
              href={PHONE_TEL}
              className="mt-4 inline-block text-xs font-semibold uppercase tracking-wide text-primary"
            >
              {PHONE_DISPLAY} →
            </a>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default WagAndWinePage;
